import { Component, computed, input, linkedSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  imports: [FormsModule],
})
export class PaginatorComponent {
  readonly prevPage = input<() => void>(() => undefined);
  readonly nextPage = input<() => void>(() => undefined);
  readonly pageSizeChanged = input<(pageSize: number) => void>(() => undefined);
  readonly pageSize = input(10);
  readonly pageNumber = input(1);
  readonly pageResultsSize = input(0);
  readonly totalResultsSize = input(0);

  /** Local writable size synced from the parent input for the select control. */
  readonly selectedPageSize = linkedSignal(() => this.pageSize());

  readonly isNextDisabled = computed(() => {
    const docsSize = this.pageResultsSize() * this.pageNumber();
    return this.pageResultsSize() < this.pageSize() || docsSize >= this.totalResultsSize();
  });

  sizeChanged(): void {
    this.pageSizeChanged()(Number(this.selectedPageSize()));
  }

  onPrev(): void {
    this.prevPage()();
  }

  onNext(): void {
    this.nextPage()();
  }
}
